export const SET_DATE = 'SET_DATE';
export const GET_EVENTS = 'GET_EVENTS';
export const GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS';
export const GET_EVENTS_FAILURE = 'GET_EVENTS_FAILURE';
export const ADD_EVENT = 'ADD_EVENT';
export const ADD_EVENT_SUCCESS = 'ADD_EVENT_SUCCESS';
export const ADD_EVENT_FAILURE = 'ADD_EVENT_FAILURE';
export const VIEW_EVENT = 'VIEW_EVENT';
export const VIEW_EVENT_SUCCESS = 'VIEW_EVENT_SUCCESS';
export const VIEW_EVENT_FAILURE = 'VIEW_EVENT_FAILURE';
export const DELETE_EVENT = 'DELETE_EVENT';
export const DELETE_EVENT_SUCCESS = 'DELETE_EVENT_SUCCESS';
export const DELETE_EVENT_FAILURE = 'DELETE_EVENT_FAILURE';



// WEBPACK FOOTER //
// ./src/types/calendar_actiontypes.js